import { mutatorAction } from "satcheljs";
import { getStore } from "../store/store";
import type { CalendarsUnionType } from "owa-graph-schema";

const updateEligibleCalendarsMutator: (smtpAddress: string, calendar: CalendarsUnionType) => void = mutatorAction("updateEligibleCalendars", function updateEligibleCalendars(smtpAddress: string, calendar: CalendarsUnionType): void {
    if (!smtpAddress) {
        return;
    }
    getStore().eligibleCalendars.set(smtpAddress, calendar);
});
export default updateEligibleCalendarsMutator;
